import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MuiBadge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import SellIcon from "@mui/icons-material/Sell";
import AdjustIcon from "@mui/icons-material/Adjust";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import EditNoteIcon from "@mui/icons-material/EditNote";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SummarizeIcon from "@mui/icons-material/Summarize";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChangeTargetOutcome from "../../../../../../components/Modals/LeadActions/Components/ChangeTargetOutcome.js";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const InvestigatingCard = ({ lead, userId, userFullName, dashPerspective, handleOpenLeadActionsModal, cardIndex }) => {
  const [changeOutcomeDetails, setChangeOutcomeDetails] = useState({});

  const [menuActive, setMenuActive] = useState(false);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const openActionsMenu = Boolean(actionMenuAnchorEl);
  const [outcomeMenuAnchorEl, setOutcomeMenuAnchorEl] = useState(null);
  const openOutcomeMenu = Boolean(outcomeMenuAnchorEl);

  const handleOpenActions = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
    setMenuActive(true);
  };
  const handleCloseActions = () => {
    setActionMenuAnchorEl(null);
    setMenuActive(false);
    setOutcomeMenuAnchorEl(null);
  };
  
  const handleOpenOutcomeMenu = (event, leadId, timeline, oldOutcome) => {
    let newOutcome = "";
    if (oldOutcome === "renegotiation") {
      newOutcome = "refinance";
    } else {
      newOutcome = "renegotiation";
    }
    setChangeOutcomeDetails({
      leadId: leadId, 
      timeline: timeline,
      newOutcome: newOutcome,
    });
    setOutcomeMenuAnchorEl(event.currentTarget);
  };
  const handleCloseOutcomeMenu = () => {
    setOutcomeMenuAnchorEl(null);
    setActionMenuAnchorEl(null);
    setMenuActive(false);
  };

  const mortgage = lead.belongsToMortgage;
  const hasLeadNotifications = lead.notifCount && lead.notifCount !== 0;
  const hasAssignmentOrUpdateNotice =
    lead.newAssignmentNotification || hasLeadNotifications;

  return (
    <>
      <RankIndex>{cardIndex + 1}</RankIndex>

      <SideRail>
        <VerticalActionButton
          type="button"
          className={
            lead.tier === 0 || lead.tier === 5
              ? "manual"
              : lead.tier === 1
                ? "tierOne"
                : lead.tier === 2
                  ? "tierTwo"
                  : "tierThree"
          }
          onClick={() =>
            handleOpenLeadActionsModal("compareRecords", lead, mortgage)
          }
        >
          <RotatedButtonLabel>
            {lead.tier === 0 || lead.tier === 5 ? (
              <>
                Manual Investigation
                <OpenInNewIcon />
              </>
            ) : (
              <>
                {mortgage.activeDiscrepancies > 0 && (
                  <InlineBadge>{mortgage.activeDiscrepancies}</InlineBadge>
                )}
                Tier {lead.tier}
                <OpenInNewIcon />
              </>
            )}
          </RotatedButtonLabel>
        </VerticalActionButton>

        <VerticalActionButton
          type="button"
          className={menuActive ? "active actions" : "actions"}
          onClick={handleOpenActions}
        >
          <RotatedButtonLabel>
            Actions
            {lead.userNotifications > 0 ? (
              <ActionNotificationBadge
                badgeContent={lead.userNotifications}
                color="error"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <KeyboardArrowDownIcon />
              </ActionNotificationBadge>
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </RotatedButtonLabel>
        </VerticalActionButton>

        <StyledMenu
          anchorEl={actionMenuAnchorEl}
          open={openActionsMenu}
          onClose={handleCloseActions}
        >
          {mortgage.reports.length === 0 ? (
            <MenuItem
              onClick={handleCloseActions}
              disableRipple
              className="border topRadius disabled"
            >
              <MenuActionRow className="disabled">
                <SummarizeIcon />
                <MenuActionTitle>Reports ({mortgage.reports.length})</MenuActionTitle>
              </MenuActionRow>
            </MenuItem>
          ) : (
            <MenuItem onClick={handleCloseActions} disableRipple className="border topRadius">
              <MenuActionRow
                onClick={() =>
                  handleOpenLeadActionsModal("reports", lead, mortgage)
                }
              >
                <SummarizeIcon />
                <MenuActionTitle>Reports ({mortgage.reports.length})</MenuActionTitle>
              </MenuActionRow>
            </MenuItem>
          )}

          <MenuItem onClick={handleCloseActions} disableRipple className="border">
            <MenuActionRow
              onClick={() => handleOpenLeadActionsModal("notes", lead, mortgage)}
            >
              <EditNoteIcon />
              <MenuActionTitle>Notes ({mortgage.mortgageNotes.length})</MenuActionTitle>
            </MenuActionRow>
          </MenuItem>

          <MenuItem onClick={handleCloseActions} disableRipple className="border">
            <MenuActionRow
              onClick={() =>
                handleOpenLeadActionsModal("compareRecords", lead, mortgage)
              }
            >
              <FileCopyIcon />
              <MenuActionTitle>Compare Records</MenuActionTitle>
            </MenuActionRow>
          </MenuItem>

          <MenuItem onClick={handleCloseActions} disableRipple className="border">
            <MenuActionRow
              onClick={() =>
                handleOpenLeadActionsModal("propertyDetails", lead, mortgage)
              }
            >
              <HomeWorkIcon />
              <MenuActionTitle>Property Details</MenuActionTitle>
            </MenuActionRow>
          </MenuItem>

          {!mortgage.financialsPresent && (
            <MenuItem onClick={handleCloseActions} disableRipple className="border caution">
              <MenuActionRow
                onClick={() =>
                  handleOpenLeadActionsModal("provideFinancialsCard", lead, mortgage)
                }
              >
                <AttachMoneyIcon />
                <MenuActionTitle>Provide Financials</MenuActionTitle>
              </MenuActionRow>
              <TodoBadge>ToDo</TodoBadge>
            </MenuItem>
          )}

          <MenuItem
            onClick={(e) =>
              handleOpenOutcomeMenu(e, lead._id, lead.timeline, lead.targetOutcome)
            }
            disableRipple
            className="border"
          >
            <MenuActionRow>
              <FlagCircleIcon />
              <MenuActionTitle>
                {lead.targetOutcome === "renegotiation"
                  ? "Switch to Refinance"
                  : "Switch to Renegotiation"}
              </MenuActionTitle>
            </MenuActionRow>
          </MenuItem>

          <MenuItem onClick={handleCloseActions} disableRipple className="border">
            <MenuActionRow
              onClick={() =>
                handleOpenLeadActionsModal("editTargets", lead, mortgage)
              }
            >
              <AdjustIcon />
              <MenuActionTitle>Change Targets</MenuActionTitle>
            </MenuActionRow>
          </MenuItem>

          <MenuItem onClick={handleCloseActions} disableRipple className="border">
            <MenuActionRow
              onClick={() => handleOpenLeadActionsModal("editTags", lead, mortgage)}
            >
              <SellIcon />
              <MenuActionTitle>Manage Tags</MenuActionTitle>
            </MenuActionRow>
          </MenuItem>

          <MenuItem onClick={handleCloseActions} disableRipple className="border">
            <MenuActionRow
              onClick={() =>
                handleOpenLeadActionsModal("addAssignees", lead, mortgage)
              }
            >
              <PersonAddIcon />
              <MenuActionTitle>Manage Assignees</MenuActionTitle>
            </MenuActionRow>
          </MenuItem>

          <MenuItem onClick={handleCloseActions} className="button buttonTop" disableRipple>
            <MenuFooterAction
              className="advance"
              onClick={() =>
                handleOpenLeadActionsModal("beginClosingLead", lead, mortgage)
              }
            >
              Begin Closing
            </MenuFooterAction>
          </MenuItem>

          <MenuItem onClick={handleCloseActions} className="button bottomRadius" disableRipple>
            <MenuFooterAction
              className="dismiss"
              onClick={() =>
                handleOpenLeadActionsModal("dismissLead", lead, mortgage)
              }
            >
              Dismiss
            </MenuFooterAction>
          </MenuItem>
        </StyledMenu>

        <StyledMenu
          anchorEl={outcomeMenuAnchorEl}
          open={openOutcomeMenu}
          onClose={handleCloseOutcomeMenu}
        >
          <ChangeTargetOutcome
            userId={userId}
            userFullName={userFullName}
            changeOutcomeDetails={changeOutcomeDetails}
            dashPerspective={dashPerspective}
          />
        </StyledMenu>
      </SideRail>

      <CardShell>
        <HeaderRow>
          <HeaderLeft>
            {hasAssignmentOrUpdateNotice ? (
              <StatusPill
                className={hasLeadNotifications ? "notification active" : "notification"}
                onClick={() =>
                  handleOpenLeadActionsModal("compareRecords", lead, mortgage)
                }
              >
                <NotificationsIcon />
                {hasLeadNotifications && (
                  <NotificationBadge>{lead.notifCount}</NotificationBadge>
                )}
                {lead.newAssignmentNotification ? "Assigned" : "Updates"}
              </StatusPill>
            ) : lead.newLeadLabel ? (
              <StatusPill
                className="new"
                onClick={() =>
                  handleOpenLeadActionsModal("compareRecords", lead, mortgage)
                }
              >
                <FlagCircleIcon />
                New
              </StatusPill>
            ) : (
              <StatusPill className="quiet">Active Review</StatusPill>
            )}

            <OutcomePill className={lead.targetOutcome}>
              {lead.targetOutcome === "renegotiation"
                ? "Renegotiation"
                : "Refinance"}
            </OutcomePill>
          </HeaderLeft>

          <HeaderMeta>
            <span>Investigation ID</span>
            <strong>{lead._id?.slice?.(-8) || "Active"}</strong>
          </HeaderMeta>
        </HeaderRow>

        <DetailGrid>
          <InfoPanel className="summary">
            <PanelTitle>Investigation Summary</PanelTitle>

            <DetailList>
              {lead.tier !== 0 && (
                <DetailRow label="Date Discovered" value={lead.dateDiscoveredLabel} />
              )}
              <DetailRow label="Began Investigation" value={lead.dateInvestigating} />
              <DetailRow
                label="Active Discrepancies"
                value={mortgage.activeDiscrepancies > 0 ? mortgage.activeDiscrepancies : "-none-"}
                muted={mortgage.activeDiscrepancies <= 0}
              />
              <DetailRow
                label="Inactive Discrepancies"
                value={getInactiveDiscrepanciesLabel(mortgage)}
                muted={getInactiveDiscrepanciesLabel(mortgage) === "-none-"}
              />
              <DetailRow
                label={lead.assigneeNames.length === 1 ? "Assignee" : "Assignees"}
                value={getAssigneeValue(lead.assigneeNames)}
                muted={lead.assigneeNames.length === 0}
              />
            </DetailList>
          </InfoPanel>

          <InfoPanel className="mortgage">
            <PanelTitle>Mortgage Information</PanelTitle>

            <DetailList>
              <DetailRow
                label="Address"
                value={
                  mortgage.streetAddress.length > 0 ? (
                    <>
                      <span>{mortgage.streetAddress}</span>
                      <span>
                        {mortgage.recordDetails.address.City.currentValue},{" "}
                        {mortgage.recordDetails.address.StateOrProvince.currentValue}{" "}
                        {mortgage.recordDetails.address.PostalCode.currentValue}
                      </span>
                    </>
                  ) : (
                    "-N/A-"
                  )
                }
                muted={mortgage.streetAddress.length === 0}
              />
              <DetailRow
                label={getBorrowerLabel(mortgage)}
                value={getBorrowerValue(mortgage)}
                muted={!mortgage.owner1 && !mortgage.owner2}
              />
              <DetailRow label={getTermLabel(mortgage)} value={getTermValue(mortgage)} />
              <DetailRow
                label="Remaining"
                value={mortgage.remainingTerm.length > 0 ? mortgage.remainingTerm : "-N/A-"}
                muted={mortgage.remainingTerm.length === 0}
              />
            </DetailList>
          </InfoPanel>

          <InfoPanel className="financials">
            <PanelTitle>Financials</PanelTitle>

            <DetailList>
              {mortgage.originalLoanAmount > 0 && (
                <DetailRow label="Loan Amount" value={formatCurrency(mortgage.originalLoanAmount)} />
              )}
              {mortgage.principalRemaining > 0 && (
                <DetailRow label="Principal Remaining" value={formatCurrency(mortgage.principalRemaining)} />
              )}
              {mortgage.originalInterestRate > 0 && (
                <DetailRow label="Original Interest Rate" value={`${mortgage.originalInterestRate}%`} />
              )}
              {mortgage.originalInterestDue > 0 && (
                <DetailRow label="Original Interest Due" value={formatCurrency(mortgage.originalInterestDue)} />
              )}
              {mortgage.interestRemaining > 0 && (
                <DetailRow label="Current Interest Due" value={formatCurrency(mortgage.interestRemaining)} />
              )}
            </DetailList>
          </InfoPanel>

          <InfoPanel className="potential">
            <PanelTitle>Refinance Potential</PanelTitle>

            {mortgage.financialsPresent ? (
              <DetailList>
                <DetailRow label="Target Interest Rate" value={`${lead.targetInterestRate}%`} />
                <DetailRow label="Target Interest Due" value={formatCurrency(lead.targetInterestDue)} />
                <ImpactRow
                  label="Change in Interest Owed"
                  value={formatProfitNumber(lead.targetProfitNumber)}
                  positive={parseInt(lead.targetProfitNumber) >= 0}
                  negative={parseInt(lead.targetProfitNumber) < 0}
                />
                <ImpactRow
                  label="Change in Revenue"
                  value={`${lead.targetProfitPercent}%`}
                  positive={parseInt(lead.targetProfitPercent) >= 0}
                  negative={parseInt(lead.targetProfitPercent) < 0}
                />
              </DetailList>
            ) : (
              <CtaChip
                type="button"
                onClick={() =>
                  handleOpenLeadActionsModal("provideFinancialsCard", lead, mortgage)
                }
              >
                <AddCircleOutlineIcon />
                Provide Original Terms
              </CtaChip>
            )}
          </InfoPanel>
        </DetailGrid>

        <TagArea>
          <TagGroup>
            <TagLabel>mortgage tags:</TagLabel>
            {mortgage.tags.length === 0 ? (
              <EmptyTags>
                <span>no mortgage tags</span>
                <AddTagButton
                  type="button"
                  onClick={() => handleOpenLeadActionsModal("editTags", lead, mortgage)}
                >
                  <AddCircleOutlineIcon />
                </AddTagButton>
              </EmptyTags>
            ) : (
              <TagList>
                {mortgage.tags.map((tag) =>
                  tag.apiMapping === "loanType" || tag.apiMapping === "propertyType" ? (
                    <TagButton
                      key={tag.tagId}
                      type="button"
                      className="mortgageTag"
                      onClick={() => handleOpenLeadActionsModal("editTags", lead, mortgage)}
                    >
                      <strong>{tag.label}</strong> - {tag.discrepancyFields[0].toUpperCase()}
                    </TagButton>
                  ) : null
                )}
                {mortgage.tags.map((tag) =>
                  tag.apiMapping !== "loanType" && tag.apiMapping !== "propertyType" ? (
                    <TagButton
                      key={tag.tagId}
                      type="button"
                      className="mortgageTag"
                      onClick={() => handleOpenLeadActionsModal("editTags", lead, mortgage)}
                    >
                      {tag.label}
                    </TagButton>
                  ) : null
                )}
              </TagList>
            )}
          </TagGroup>

          <TagGroup>
            <TagLabel>investigation tags:</TagLabel>
            {lead.tags.length === 0 ? (
              <EmptyTags>
                <span>no lead tags</span>
                <AddTagButton
                  type="button"
                  onClick={() => handleOpenLeadActionsModal("editTags", lead, mortgage)}
                >
                  <AddCircleOutlineIcon />
                </AddTagButton>
              </EmptyTags>
            ) : (
              <TagList>
                {lead.tags.map((tag) => (
                  <TagButton
                    type="button"
                    key={tag.tagId}
                    onClick={() => handleOpenLeadActionsModal("editTags", lead, mortgage)}
                  >
                    {tag.label}
                  </TagButton>
                ))}
              </TagList>
            )}
          </TagGroup>
        </TagArea>
      </CardShell>
    </>
  );
};

const DetailRow = ({ label, value, muted = false }) => (
  <DataRow>
    <DataLabel>{label}:</DataLabel>
    <DataValue className={muted ? "muted" : ""}>{value}</DataValue>
  </DataRow>
);

const ImpactRow = ({ label, value, positive, negative }) => (
  <DataRow>
    <DataLabel>{label}:</DataLabel>
    <ImpactValue className={positive ? "positive" : negative ? "negative" : ""}>
      {value}
    </ImpactValue>
  </DataRow>
);

const getInactiveDiscrepanciesLabel = (mortgage) => {
  if (mortgage.rejectedDiscrepancies === 0 && mortgage.resolvedDiscrepancies === 0) {
    return "-none-";
  }

  if (mortgage.rejectedDiscrepancies === 0 && mortgage.resolvedDiscrepancies > 0) {
    return `${mortgage.resolvedDiscrepancies} resolved`;
  }

  if (mortgage.rejectedDiscrepancies > 0 && mortgage.resolvedDiscrepancies === 0) {
    return `${mortgage.rejectedDiscrepancies} rejected`;
  }

  return `${mortgage.resolvedDiscrepancies} resolved, ${mortgage.rejectedDiscrepancies} rejected`;
};

const getBorrowerLabel = (mortgage) => {
  if (mortgage.owner1 && mortgage.owner2) return "Borrowers";
  if (mortgage.owner1 || mortgage.owner2) return "Borrower";
  return "Borrowers";
};

const getBorrowerValue = (mortgage) => {
  if (mortgage.owner1.length > 0 && mortgage.owner2.length > 0) {
    return (
      <StackedValue>
        <span>{mortgage.owner1}</span>
        <span>{mortgage.owner2}</span>
      </StackedValue>
    );
  }

  if (mortgage.owner1.length > 0) return mortgage.owner1;
  if (mortgage.owner2.length > 0) return mortgage.owner2;
  return "-N/A-";
};

const getAssigneeValue = (assigneeNames) => {
  if (assigneeNames.length === 0) return "-none-";
  if (assigneeNames.length === 1) return assigneeNames[0];

  return (
    <>
      {assigneeNames.map((assignee) => (
        <span key={assignee}>{assignee}</span>
      ))}
    </>
  );
};

const getTermLabel = (mortgage) => {
  if (mortgage.originationDateLabel.length > 0 && mortgage.endDateLabel.length === 0) {
    return "Originated";
  }

  if (mortgage.endDateLabel.length > 0 && !mortgage.originationDateLabel.length > 0) {
    return "Terminates";
  }

  return "Term";
};

const getTermValue = (mortgage) => {
  if (mortgage.originationDateLabel.length > 0 && mortgage.endDateLabel.length > 0) {
    return (
      <InlinePair>
        <span>{mortgage.originationDateLabel}</span>
        <small>to</small>
        <span>{mortgage.endDateLabel}</span>
      </InlinePair>
    );
  }

  if (mortgage.originationDateLabel.length > 0) return mortgage.originationDateLabel;
  if (mortgage.endDateLabel.length > 0) return mortgage.endDateLabel;
  return "-N/A-";
};

const formatCurrency = (value) =>
  `$${value.toLocaleString("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  })}`;

const formatProfitNumber = (value) => {
  if (parseInt(value) < 0) {
    return `-${formatCurrency(value * -1)}`;
  }

  return formatCurrency(value);
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    minWidth: "17rem",
    border: `0.1rem solid ${theme.palette.common.grayBorder}`,
    borderRadius: "0.8rem",
    background: theme.palette.common.grayBorder,
    boxShadow: "0 1rem 2rem rgba(15, 23, 42, 0.14)",

    "& .MuiMenu-list": {
      padding: "0.35rem",
    },

    "& .MuiMenuItem-root": {
      background: theme.palette.common.pageBackground,

      "&.buttonTop": {
        padding: "0.8rem 0.8rem 0.4rem",
        justifyContent: "center",
      },

      "&.border": {
        borderBottom: `0.1rem solid ${theme.palette.common.grayBorder}`,
      },

      "&.topRadius": {
        borderRadius: "0.55rem 0.55rem 0 0",
      },

      "&.bottomRadius": {
        borderRadius: "0 0 0.55rem 0.55rem",
        padding: "0.4rem 0.8rem 0.8rem",
        justifyContent: "center",
      },

      "&.disabled": {
        background: theme.palette.common.disabledGray,
      },

      "&.caution": {
        background: "#fff4e6",
      },
    },

    "& .MuiMenuItem-root:hover": {
      background: theme.palette.common.grayHover,

      "&.button": {
        background: theme.palette.common.pageBackground,
      },
    },
  },
}));

export default InvestigatingCard;

const RankIndex = styled("div")(({ theme }) => ({
  width: "2.2rem",
  minWidth: "2.2rem",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.common.grayText,
  fontSize: "1rem",
  fontWeight: 900,
  letterSpacing: 0,
  background: "rgba(248,250,252,0.84)",
  borderRight: `0.1rem solid ${theme.palette.common.grayBorder}`,
}));

const SideRail = styled("div")(({ theme }) => ({
  width: "5.4rem",
  minWidth: "5.4rem",
  height: "100%",
  display: "flex",
  alignItems: "stretch",
  justifyContent: "center",
  gap: "0.35rem",
  padding: "0.65rem 0.35rem",
  borderRight: `0.1rem solid ${theme.palette.common.grayBorder}`,
  background: "rgba(248,250,252,0.82)",
}));

const VerticalActionButton = styled("button")({
  width: "2.1rem",
  minWidth: "2.1rem",
  height: "100%",
  minHeight: "12rem",
  border: "none",
  borderRadius: "0.55rem",
  cursor: "pointer",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "none",
  transition: "transform 160ms ease, box-shadow 160ms ease, background 160ms ease",

  "&:hover": {
    transform: "translateY(-0.1rem)",
    boxShadow: "0 0.5rem 1.1rem rgba(15, 23, 42, 0.13)",
  },

  "& svg": {
    width: "1.15rem",
    height: "1.15rem",
  },

  "&.manual": {
    background: "#475569",
  },

  "&.tierOne": {
    background: "#dc2626",
  },

  "&.tierTwo": {
    background: "#7c3aed",
  },

  "&.tierThree": {
    background: "#0f766e",
  },

  "&.actions": {
    background: "#334155",
  },

  "&.active": {
    background: "#1e40af",
    boxShadow: "0 0 0 0.16rem rgba(37,99,235,0.16)",
  },
});

const RotatedButtonLabel = styled("span")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.3rem",
  transform: "rotate(-90deg)",
  whiteSpace: "nowrap",
  textTransform: "uppercase",
  fontSize: "0.82rem",
  fontWeight: 950,
  letterSpacing: 0,
});

const InlineBadge = styled("span")({
  minWidth: "1.7rem",
  height: "1.7rem",
  padding: "0 0.45rem",
  borderRadius: "999px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#0f172a",
  background: "#fff",
  boxShadow: "inset 0 0 0 0.1rem rgba(15,23,42,0.14)",
  fontSize: "0.78rem",
  fontWeight: 950,
});

const ActionNotificationBadge = styled(MuiBadge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.error,
    fontWeight: 800,
    fontSize: "1rem",
    height: "1.4rem",
    padding: "0 0.5rem",
    borderRadius: "1rem",
    minWidth: "1.2rem",
  },
}));

const CardShell = styled("section")(({ theme }) => ({
  width: "100%",
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  padding: "1rem 1.2rem 0.9rem 1.2rem",
  background: "rgba(255,255,255,0.8)",
}));

const HeaderRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "1rem",
  padding: "0 0 0.8rem 0",
  borderBottom: `0.1rem solid ${theme.palette.common.grayBorder}`,
}));

const HeaderLeft = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.8rem",
  minWidth: 0,
});

const HeaderMeta = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  color: theme.palette.common.grayText,
  fontSize: "0.82rem",
  textTransform: "uppercase",
  letterSpacing: 0,

  "& strong": {
    color: "#0f172a",
    fontSize: "1rem",
    fontWeight: 800,
  },
}));

const StatusPill = styled("button")(({ theme }) => ({
  height: "2.6rem",
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "0.65rem",
  padding: "0 0.85rem",
  display: "inline-flex",
  alignItems: "center",
  gap: "0.45rem",
  color: "#334155",
  background: "#fff",
  fontSize: "0.88rem",
  fontWeight: 900,
  letterSpacing: 0,
  cursor: "default",

  "& svg": {
    width: "1.55rem",
    height: "1.55rem",
  },

  "&.new, &.notification": {
    cursor: "pointer",
  },

  "&.new": {
    color: "#1e40af",
    borderColor: "rgba(37,99,235,0.24)",
    background: "rgba(37,99,235,0.08)",
  },

  "&.notification.active": {
    color: "#9a3412",
    borderColor: "rgba(234,88,12,0.25)",
    background: "rgba(251,146,60,0.12)",
  },

  "&.quiet": {
    color: theme.palette.common.grayText,
    background: "rgba(248,250,252,0.95)",
  },
}));

const NotificationBadge = styled("span")({
  width: "1.6rem",
  height: "1.6rem",
  borderRadius: "0.65rem",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  background: "#dc2626",
  fontSize: "0.9rem",
  fontWeight: 900,
});

const OutcomePill = styled("div")({
  height: "2.6rem",
  display: "inline-flex",
  alignItems: "center",
  padding: "0 1rem",
  borderRadius: "999px",
  fontSize: "0.96rem",
  fontWeight: 900,
  letterSpacing: 0,

  "&.refinance": {
    color: "#065f46",
    background: "rgba(16,185,129,0.1)",
    border: "0.1rem solid rgba(16,185,129,0.22)",
  },

  "&.renegotiation": {
    color: "#5b21b6",
    background: "rgba(124,58,237,0.1)",
    border: "0.1rem solid rgba(124,58,237,0.22)",
  },
});

const DetailGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "22rem minmax(28rem, 1fr) minmax(20rem, 0.85fr) 24rem",
  gap: "1rem",
  padding: "1rem 0 0.8rem 0",
  alignItems: "stretch",
});

const InfoPanel = styled("article")(({ theme }) => ({
  minWidth: 0,
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "0.7rem",
  background: "#fff",
  boxShadow: "none",
  overflow: "hidden",

  "&.summary": {
    borderLeft: "0.24rem solid #334155",
  },

  "&.mortgage": {
    borderLeft: "0.24rem solid #2563eb",
  },

  "&.financials": {
    borderLeft: "0.24rem solid #0f766e",
  },

  "&.potential": {
    borderLeft: "0.24rem solid #7c3aed",
  },
}));

const PanelTitle = styled("div")(({ theme }) => ({
  height: "3rem",
  display: "flex",
  alignItems: "center",
  padding: "0 1rem",
  color: "#0f172a",
  background: "rgba(248,250,252,0.95)",
  borderBottom: `0.1rem solid ${theme.palette.common.grayBorder}`,
  fontSize: "0.88rem",
  fontWeight: 900,
  textTransform: "uppercase",
  letterSpacing: 0,
}));

const DetailList = styled("div")({
  display: "grid",
  gap: "0.36rem",
  padding: "0.9rem 1rem 1rem 1rem",
});

const DataRow = styled("div")({
  minWidth: 0,
  display: "grid",
  gridTemplateColumns: "8.2rem minmax(0, 1fr)",
  gap: "0.55rem",
  alignItems: "start",
});

const DataLabel = styled("span")(({ theme }) => ({
  color: theme.palette.common.grayText,
  fontSize: "0.76rem",
  fontWeight: 850,
  lineHeight: 1.2,
  textAlign: "right",
}));

const DataValue = styled("span")({
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  color: "#0f172a",
  fontSize: "0.82rem",
  fontWeight: 900,
  lineHeight: 1.2,

  "&.muted": {
    color: "#64748b",
    fontWeight: 750,
  },

  "& span": {
    minWidth: 0,
    color: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
  },
});

const ImpactValue = styled(DataValue)({
  fontSize: "1rem",

  "&.positive": {
    color: "#15803d",
  },

  "&.negative": {
    color: "#dc2626",
  },
});

const InlinePair = styled("span")({
  display: "inline-flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "0.28rem",
  minWidth: 0,
  maxWidth: "100%",
  color: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",

  "& span": {
    minWidth: 0,
    color: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
  },

  "& small": {
    display: "inline-flex",
    alignItems: "center",
    alignSelf: "center",
    color: "#64748b",
    fontSize: "0.76rem",
    fontWeight: 750,
    lineHeight: 1,
  },
});

const StackedValue = styled("span")({
  minWidth: 0,
  display: "inline-flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "0.12rem",
  color: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",
});

const CtaChip = styled("button")({
  margin: "1.1rem auto",
  height: "3.2rem",
  width: "fit-content",
  padding: "0 1rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.5rem",
  borderRadius: "0.65rem",
  border: "0.1rem solid rgba(234,88,12,0.25)",
  background: "rgba(251,146,60,0.14)",
  color: "#9a3412",
  fontSize: "0.88rem",
  fontWeight: 900,
  cursor: "pointer",

  "&:hover": {
    background: "rgba(251,146,60,0.22)",
  },
});

const TagArea = styled("div")(({ theme }) => ({
  display: "grid",
  gap: "0.42rem",
  paddingTop: "0.4rem",
  borderTop: `0.1rem solid ${theme.palette.common.grayBorder}`,
}));

const TagGroup = styled("div")({
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
});

const TagLabel = styled("span")(({ theme }) => ({
  color: theme.palette.common.grayText,
  fontSize: "0.78rem",
  fontWeight: 900,
  whiteSpace: "nowrap",
}));

const TagList = styled("div")({
  minWidth: 0,
  display: "flex",
  flexWrap: "wrap",
  gap: "0.35rem",
});

const TagButton = styled("button")(({ theme }) => ({
  minHeight: "1.85rem",
  display: "inline-flex",
  alignItems: "center",
  gap: "0.25rem",
  padding: "0.15rem 0.55rem",
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "0.55rem",
  background: "#fff",
  color: "#334155",
  cursor: "pointer",
  fontSize: "0.78rem",
  fontWeight: 850,

  "& strong": {
    color: theme.palette.common.grayBorderDarkest,
    fontSize: "0.78rem",
    fontWeight: 900,
  },

  "&.mortgageTag": {
    background: "rgba(248,250,252,0.92)",
  },
}));

const EmptyTags = styled("div")({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.35rem",
  color: "#64748b",
  fontSize: "0.78rem",
  fontWeight: 800,
});

const AddTagButton = styled("button")(({ theme }) => ({
  width: "1.6rem",
  height: "1.6rem",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "50%",
  background: "#fff",
  color: theme.palette.primary.main,
  cursor: "pointer",

  "& svg": {
    width: "1rem",
    height: "1rem",
  },
}));

const MenuActionRow = styled("div")(({ theme }) => ({
  width: "100%",
  minHeight: "2.35rem",
  display: "flex",
  alignItems: "center",
  gap: "0.8rem",
  padding: "0 0.8rem",
  color: "#334155",
  cursor: "pointer",

  "& svg": {
    color: theme.palette.common.grayText,
    width: "1.55rem",
    height: "1.55rem",
  },

  "&:hover": {
    color: "#0f172a",

    "& svg": {
      color: "#2563eb",
    },
  },

  "&.disabled": {
    cursor: "not-allowed",
    opacity: 0.55,
  },
}));

const MenuActionTitle = styled("div")({
  fontSize: "0.9rem",
  fontWeight: 850,
});

const TodoBadge = styled("div")({
  marginLeft: "auto",
  marginRight: "0.8rem",
  color: "#9a3412",
  fontSize: "0.72rem",
  fontWeight: 900,
  textTransform: "uppercase",
  letterSpacing: 0,
});

const MenuFooterAction = styled("button")({
  width: "100%",
  height: "2.4rem",
  border: "none",
  borderRadius: "0.55rem",
  color: "#fff",
  fontSize: "0.9rem",
  fontWeight: 900,
  cursor: "pointer",

  "&.advance": {
    background: "#0f766e",
  },

  "&.dismiss": {
    background: "#dc2626",
  },
});
